import { ArrowRightIcon, PlusIcon } from '@heroicons/react/24/outline';

export interface ShowMoreProps {
  actionText: string;
  onClick: (value: string) => void;
  category: string;
}

export function ShowMore({ actionText, onClick, category }: ShowMoreProps) {
  return (
    <div className="group cursor-pointer transform transition-transform duration-300 hover:translate-y-[-5px]">
      <div
        onClick={() => onClick(category)}
        className="flex h-[159px] w-[225px] flex-col items-center justify-center rounded-xl bg-gradient-to-br from-primary-50 to-gray-50 border border-gray-200 group-hover:border-primary-300 shadow-sm group-hover:shadow-md transition-all duration-300"
      >
        <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm group-hover:shadow-md transition-all duration-300 mb-2 group-hover:bg-primary-50">
          <PlusIcon className="h-6 w-6 text-primary-600 group-hover:text-primary-700 transition-colors duration-300" />
        </div>
        <p className="font-nunito text-base font-medium text-gray-800 group-hover:text-primary-700 transition-colors duration-300">
          {actionText}
        </p>
        <div className="mt-3 flex items-center text-primary-600 text-sm font-medium">
          <span>View all</span>
          <ArrowRightIcon className="h-4 w-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </div>
  );
}

export default ShowMore;
